import { render, staticRenderFns } from "./tj-title-bar.vue?vue&type=template&id=43ab4680&scoped=true"
import script from "./tj-title-bar.vue?vue&type=script&lang=js"
export * from "./tj-title-bar.vue?vue&type=script&lang=js"
import style0 from "./tj-title-bar.vue?vue&type=style&index=0&id=43ab4680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ab4680",
  null
  
)

export default component.exports